namespace Roodik.Core
{
	export abstract class ViewBase extends Sprite
	{
		constructor(name?:string)
		{
			super(name);
		}

		public destroy()
		{
			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Base/ViewBase.ts